(function () {
  'use strict';

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    var selectors = [
      '#shopify-section-collections .collection-list-grid__item',
      '#shopify-section-featured-products .grid__item',
      '#shopify-section-how-it-works .multicolumn-card',
      '#shopify-section-promise-bar .rich-text__blocks > *',
      '#shopify-section-cta .rich-text__blocks > *'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        el.classList.add('os-reveal');
        if (i === 1) el.classList.add('os-reveal-d1');
        if (i === 2) el.classList.add('os-reveal-d2');
        if (i === 3) el.classList.add('os-reveal-d3');
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('os-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.os-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---- Header glass on scroll ---- */
  function initHeader() {
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    function onScroll() {
      if (window.scrollY > 40) hw.classList.add('os-scrolled');
      else hw.classList.remove('os-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Hero floating particles ---- */
  function initParticles() {
    var hero = document.querySelector('#shopify-section-hero .banner');
    if (!hero) return;
    for (var i = 0; i < 12; i++) {
      var p = document.createElement('span');
      p.className = 'os-particle';
      p.style.cssText = [
        'left:' + (5 + Math.random() * 90) + '%',
        'top:' + (10 + Math.random() * 80) + '%',
        'width:' + (2 + Math.random() * 3) + 'px',
        'height:' + (2 + Math.random() * 3) + 'px',
        'animation-delay:' + (Math.random() * 6) + 's',
        'animation-duration:' + (6 + Math.random() * 6) + 's'
      ].join(';');
      hero.appendChild(p);
    }
  }

  /* ---- Step numbers ---- */
  function initStepNumbers() {
    var cards = document.querySelectorAll('#shopify-section-how-it-works .multicolumn-card');
    cards.forEach(function (card, i) {
      var num = document.createElement('div');
      num.className = 'os-step-num';
      num.textContent = '0' + (i + 1);
      card.insertBefore(num, card.firstChild);
    });
  }

  /* ---- Collapsible tab gold indicator ---- */
  function initTabs() {
    document.querySelectorAll('details.accordion summary').forEach(function (s) {
      s.addEventListener('click', function () {
        var detail = s.closest('details');
        setTimeout(function () {
          detail.classList.toggle('os-open', detail.open);
        }, 10);
      });
    });
  }

  function boot() {
    initReveal();
    initHeader();
    initParticles();
    initStepNumbers();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
